module.exports = __webpack_public_path__ + "lp/img/recording_dark.6ace151f.svg";